import { Col, Row, Table, Tag } from "antd";
import { filter, find, get } from "lodash";
import { useTranslation } from "react-i18next";
import {
  MdOutlineDeleteOutline,
  MdOutlineModeEditOutline,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Pagination from "shared/components/Pagination";
import { NAME_SPACES } from "shared/locales/constants";
import { COLORS } from "shared/style/colors";
import { SCREENS } from "utils/constants";

function List({ data, count, onEdit, setValues, skip }) {
  const navigate = useNavigate();
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.OFFER);
  const LIST = t("LIST", { returnObjects: true });

  const columns = [
    {
      title: LIST.NAME,
      dataIndex: "name",
      render: (name) => name || "-",
    },
    {
      title: LIST.INSURANCE_PLAN_NAME,
      render: ({ offerInsurancePlans }) =>
        get(
          find(offerInsurancePlans, { main: true }),
          "insurancePlan.name",
          "---",
        ),
    },
    {
      title: LIST.UPSELLS,
      render: ({ id: offerId, offerInsurancePlans }) => {
        const upsells = filter(offerInsurancePlans, { main: false });
        return upsells.map(({ id, insurancePlan }) => (
          <Tag key={id}>{insurancePlan?.name}</Tag>
        ));
      },
    },
    {
      title: LIST.PROCESS,
      dataIndex: "processes",
      render: (processes) => {
        return processes?.map(({ id, name }) => <Tag key={id}>{name}</Tag>);
      },
    },
    {
      title: LIST.ACTIONS,
      dataIndex: "id",
      align: "right",
      render: (id) => (
        <Row gutter={8} justify="end" align="center" wrap={false}>
          <Col onClick={() => onEdit(id)}>
            <MdOutlineModeEditOutline size={24} color={COLORS.C_GRAY} />
          </Col>
          <Col
            onClick={() =>
              navigate(`${SCREENS.PRIVATE.ADMIN.OFFERS.DELETE.path}/${id}`)
            }
          >
            <MdOutlineDeleteOutline size={24} color={COLORS.C_DANGER} />
          </Col>
        </Row>
      ),
    },
  ];

  return (
    <>
      <Table
        dataSource={data}
        className="table__wrapper"
        columns={columns}
        rowKey={"id"}
        pagination={false}
        scroll={{ x: true }}
      />
      <Pagination count={count} setValues={setValues} skip={skip} />
    </>
  );
}

export default List;
